import { Components } from '@mui/material/styles';

const muiTooltipStyles: Components = {
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        marginLeft: '8px !important',
        borderRadius: '3.5px',
        border: '0.5px solid var(--gray-alpha-500)',
        backgroundColor: 'var(--white)',
        boxShadow: '5.833px 5.833px 46.667px -8.75px rgba(70, 96, 135, 0.35)',
        color: 'var(--gray-2)',
        fontSize: '11px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
        padding: '8px 12px'
      },
      arrow: {
        color: 'var(--white)',
        filter: 'drop-shadow(0px 1px 0px #DFE5EE)'
      }
    }
  }
};

export default muiTooltipStyles;
